export const StateList = [
    { state: 'ALABAMA', code: 'AL' },
    { state: 'ALASKA', code: 'AK' },
    { state: 'ARIZONA', code: 'AZ' },
    { state: 'ARKANSAS', code: 'AR' },
    { state: 'CALIFORNIA', code: 'CA' },
    { state: 'COLORADO', code: 'CO' },
    { state: 'CONNECTICUT', code: 'CT' },
    { state: 'DELAWARE', code: 'DE' },
    { state: 'DC', code: 'DC' },
    { state: 'FLORIDA', code: 'FL' },
    { state: 'GEORGIA', code: 'GA' },
    { state: 'HAWAII', code: 'HI' },
    { state: 'IDAHO', code: 'ID' },
    { state: 'ILLINOIS', code: 'IL' },
    { state: 'INDIANA', code: 'IN' },
    { state: 'IOWA', code: 'IA' },
    { state: 'KANSAS', code: 'KS' },
    { state: 'KENTUCKY', code: 'KY' },
    { state: 'LOUISIANA', code: 'LA' },
    { state: 'MAINE', code: 'ME' },
    { state: 'MARYLAND', code: 'MD' },
    { state: 'MASSACHUSETTS', code: 'MA' },
    { state: 'MICHIGAN', code: 'MI' },
    { state: 'MINNESOTA', code: 'MN' },
    { state: 'MISSISSIPPI', code: 'MS' },
    { state: 'MISSOURI', code: 'MO' },
    { state: 'MONTANA', code: 'MT' },
    { state: 'NEBRASKA', code: 'NE' },
    { state: 'NEVADA', code: 'NV' },
    { state: 'NEW HAMPSHIRE', code: 'NH' },
    { state: 'NEW JERSEY', code: 'NJ' },
    { state: 'NEW MEXICO', code: 'NM' },
    { state: 'NEW YORK', code: 'NY' },
    { state: 'NORTH CAROLINA', code: 'NC' },
    { state: 'NORTH DAKOTA', code: 'ND' },
    { state: 'OHIO', code: 'OH' },
    { state: 'OKLAHOMA', code: 'OK' },
    { state: 'OREGON', code: 'OR' },
    { state: 'PENNSYLVANIA', code: 'PA' },
    { state: 'RHODE ISLAND', code: 'RI' },
    { state: 'SOUTH CAROLINA', code: 'SC' },
    { state: 'SOUTH DAKOTA', code: 'SD' },
    { state: 'TENNESSEE', code: 'TN' },
    { state: 'TEXAS', code: 'TX' },
    { state: 'UTAH', code: 'UT' },
    { state: 'VERMONT', code: 'VT' },
    { state: 'VIRGINIA', code: 'VA' },
    { state: 'WASHINGTON', code: 'WA' },
    { state: 'WEST VIRGINIA', code: 'WV' },
    { state: 'WISCONSIN', code: 'WI' },
    { state: 'WYOMING', code: 'WY' },
    { state: 'VIRGIN ISLANDS', code: 'VI' },
    { state: 'PALAU', code: 'PW' },
    { state: 'ARMED FORCES AMERICA', code: 'AA' },
    { state: 'ARMED FORCES EUROPE', code: 'AE' },
    { state: 'ARMED FORCES PACIFIC', code: 'AP' },
    { state: 'AMERICAN SAMOA', code: 'AS' },
    { state: 'GUAM', code: 'GU' },
    { state: 'NORTHERN MARIANA ISLANDS', code: 'MP' },
    { state: 'PUERTO RICO', code: 'PR' }
];
